var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-faq", attrs: { name: "app_faq", id: "app_faq" } },
    [
      _c("div", { staticClass: "faq-title" }, [
        _vm._v(_vm._s(_vm.getConstants("EAGLE_LANDING_FAQ_TITLE")))
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "faq-content" },
        _vm._l(_vm.faqContent, function(ref) {
          var title = ref.title
          var text = ref.text
          return _c("li", { key: title, staticClass: "faq-block" }, [
            _c("h4", { staticClass: "faq-block-title" }, [
              _vm._v(_vm._s(title))
            ]),
            _vm._v(" "),
            _c("p", {
              staticClass: "faq-block-text",
              domProps: { innerHTML: _vm._s(text) }
            })
          ])
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }